import React from "react";
import App from "./App";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import { BrowserRouter as Router, useHistory } from "react-router-dom";

import configureStore from "./store";
import ScrollTop from "./components/top/ScrollTop";
import ModalPortal from "./components/common/modals/modalPortal/ModalPortal";

export const { store, persistor } = configureStore();

const Root = () => {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <Router>
                    <ScrollTop />
                    <App />
                    <ModalPortal />
                </Router>
            </PersistGate>
        </Provider>
    );
};

export default Root;
